// Feature Flags for AKW Design
// Set to true to enable, false to disable

const featureFlags = {
  // Shop/E-Commerce Feature
  // Set to false to hide the shop from visitors
  // Set to true to re-enable the shop
  SHOP_ENABLED: false,
  
  // Other features can be added here
  CONTACT_FORM_ENABLED: true,
};

export default featureFlags;
